import { render, staticRenderFns } from "./viewReservitionCouponManagerment.vue?vue&type=template&id=280ec98c&scoped=true&"
import script from "./viewReservitionCouponManagerment.vue?vue&type=script&lang=js&"
export * from "./viewReservitionCouponManagerment.vue?vue&type=script&lang=js&"
import style0 from "./viewReservitionCouponManagerment.vue?vue&type=style&index=0&id=280ec98c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ec98c",
  null
  
)

component.options.__file = "viewReservitionCouponManagerment.vue"
export default component.exports